import classNames from 'classnames';
import React from 'react';
import styles from './Loader.scss';
var Loader = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 60 : _b, className = _a.className;
    return (React.createElement("div", { className: classNames(styles.spinner, className), style: { width: size, height: size }, "data-hook": "loader" }));
};
export default Loader;
//# sourceMappingURL=Loader.js.map